module.exports = __webpack_public_path__ + "static/media/zb-naslovna.fa7fedae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zb-naslovna.jpg
// module id = 50
// module chunks = 0